import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Flex,
  FormControl,
  FormLabel,
  Input,
  Stack,
  Text,
  useColorModeValue,
  useDisclosure,
} from '@chakra-ui/react';
import React, { useEffect, useRef, useState } from 'react';
import { importFile, useExportShortlinkMutation, useExportTemplateMutation, useQueryGetListCategory } from 'services/category';
import { CookieStorage } from 'utils/cookie-storage';
import { useHistory } from 'react-router-dom';
import { useMemo } from 'react';
import { FileExcelValid, ModalType } from 'constants/common';
import SizeTable from './components/Table';
import CreateCategoryModal from './components/CreateCategoryModal';
import Pagination from 'components/Pagination/Pagination';
import { downloadFile } from 'utils/helpers';
import { toast } from 'components/Toast';
import { useUserState } from 'context/UserContext';
import ExportModal from './components/ExportModal';

function Category() {
  const textColor = useColorModeValue('gray.700', 'white');
  const history = useHistory();
  const [sizeEditing, setSizeEditing] = useState(null);
  const [pageSizeExport, setPageSizeExport] = useState(1000);
  const [pageCurrentExport, setPageCurrentExport] = useState(1);
  const [searchTitle, setSearchTitle] = useState('');
  const [filter, setFilter] = useState({
    pageIndex: 0,
    pageSize: 10,
  });
  const exportTemplateMutation = useExportTemplateMutation();
  const inputImportRef = useRef();

  useEffect(() => {
    if (!CookieStorage.isAuthenticated()) {
      return history.push('/auth/sign-in');
    }
  }, []);

  const { isOpen: isCreateModalOpen, onOpen: onOpenCreateModal, onClose: onCloseCreateModal } = useDisclosure();
  const { isOpen: isExportModalOpen, onOpen: onOpenExportModal, onClose: onCloseExportModal } = useDisclosure();
  const { isOpen: isChangeStatusModalOpen, onOpen: onOpenChangeStatusModal, onClose: onCloseChangeStatusModal } = useDisclosure();
  const openModal = useMemo(
    () => ({
      [ModalType.Add]: onOpenCreateModal,
      [ModalType.ChangeStatus]: onOpenChangeStatusModal,
      [ModalType.Adjust]: onOpenExportModal,
    }),
    [onOpenCreateModal, onOpenChangeStatusModal, onOpenExportModal]
  );
  const closeModal = useMemo(
    () => ({
      [ModalType.Add]: onCloseCreateModal,
      [ModalType.ChangeStatus]: onCloseChangeStatusModal,
      [ModalType.Adjust]: onCloseExportModal,
    }),
    [onCloseCreateModal, onCloseChangeStatusModal, onCloseExportModal]
  );

  const { data: categoryData, refetch } = useQueryGetListCategory(
    { ...filter, searchKeyword: filter.searchTitle },
    { enabled: CookieStorage.isAuthenticated() }
  );

  const exportShortlinkMutation = useExportShortlinkMutation(
    {
      pageSize: pageSizeExport,
      pageIndex: pageCurrentExport,
      isExport: true,
      responseType: 'arraybuffer',
      searchKeyword: filter.searchTitle,
    },
    {
      responseType: 'arraybuffer',
    }
  );

  const handleUpdateItem = (size, modalType) => {
    openModal?.[modalType]?.();
    setSizeEditing(size);
  };

  const handelCloseModal = modalType => {
    closeModal?.[modalType]?.();
    setSizeEditing(null);
  };

  const handleSearch = () => {
    setFilter({
      ...filter,
      searchTitle: searchTitle,
    });
  };

  const handleReset = () => {
    setFilter({
      pageIndex: 0,
      pageSize: 10,
    });
    setSearchTitle('');
  };

  const onDownloadTemplate = () => {
    exportShortlinkMutation.mutate(undefined, {
      onSuccess: response => {
        downloadFile(response, 'shortlink');
        toast.showMessageSuccess('Tải file shortlink thành công');
      },
      onError: () => {
        toast.showMessageError('Tải file shortlink thất bại');
      },
    });
  };

  const handleExport = (number, pageCurrent) => {
    setPageCurrentExport(pageCurrent)
    setPageSizeExport(number);
    onDownloadTemplate();
  }

  const handleImportFileExcel = async e => {
    console.log(e?.target?.files?.[0])
    if (e?.target?.files?.[0]) {
      const file = e.target.files[0];
      const extensionFile = file?.name?.split('.')?.pop();

      if (FileExcelValid.includes(extensionFile)) {
        const formData = new FormData();

        formData.append('importFile', file);

        await importFile(formData)
          .then(() => {
            toast.showMessageSuccess('Tải lên danh sách shortlink thành công');
            refetch();
          })
          .catch(() => {
            toast.showMessageError('Tải lên danh sách shortlink thất bại');
          });
        e.target.value = null;
        return;
      }

      setError('Chỉ hỗ trợ tải lại file định dạng .xlsx, xls');
    }
  };

  const handleDeleteAllRecord = () => {
    if (window.confirm('Bạn có chắc chắn muốn xóa tất cả các shortlink?')) {
      // deleteCategoryMutation.mutate(
      //   { id: category?._id },
      //   {
      //     onSuccess: () => {
      //       toast.showMessageSuccess('Xóa tất cả các shortlink thành công');
      //       refetch?.();
      //     },
      //     onError: () => {
      //       toast.showMessageError('Xóa tất cả các shortlink không thành công');
      //       refetch?.();
      //     },
      //   }
      // );
    }
  };
  return (
    <Flex direction="column" pt={{ base: '120px', md: '75px', lg: '100px' }}>
      <Card p="16px" mb="24px" bg="#fff">
        <CardHeader p="12px 5px" mb="12px">
          <Flex justifyContent={'space-between'}>
            <Flex direction={'column'}>
              <Flex direction="column" gap={'30px'}>
                <Text fontSize="xl" color={textColor} fontWeight="bold">
                  Danh sách short link
                </Text>
              </Flex>
              <Flex justifyContent={'space-between'} alignItems={'end'} gap={'20px'} mt={'20px'}>
                <Stack>
                  <Flex alignItems={'center'} gap={'20px'} flexWrap={{ base: 'wrap', md: 'nowrap' }}>
                    <FormControl minWidth={{ base: 'full', sm: '300px' }}>
                      <FormLabel>Tìm kiếm</FormLabel>
                      <Input value={searchTitle} onChange={e => setSearchTitle(e.target.value)} />
                    </FormControl>
                    <Button maxH="40px" alignSelf={'end'} onClick={handleReset}>
                      <Text fontSize="md" fontWeight="bold" cursor="pointer">
                        Cài lại
                      </Text>
                    </Button>
                    <Button variant="primary" maxH="40px" alignSelf={'end'} onClick={handleSearch}>
                      <Text fontSize="md" fontWeight="bold" cursor="pointer">
                        Tìm kiếm
                      </Text>
                    </Button>
                  </Flex>
                </Stack>
              </Flex>
            </Flex>
            <Flex alignItems={'start'} gap={4}>
              <Button bg="blue.500" color="white" onClick={() => handleUpdateItem(null, ModalType.Adjust)}>
                <Text fontSize="md" fontWeight="bold" cursor="pointer">
                  Export
                </Text>
              </Button>
              <Button bg="#3182ce" color="#fff" _hover={{ bg: '#67a1d7' }} onClick={onOpenCreateModal}>
                <Text fontSize="md" fontWeight="bold" cursor="pointer">
                  Thêm
                </Text>
              </Button>
              <Flex alignItems="center">
                <input type="file" hidden ref={inputImportRef} onChange={handleImportFileExcel} />
                <Button
                  bg="#3182ce"
                  color="#fff"
                  _hover={{ bg: '#67a1d7' }}
                  onClick={() => {
                    inputImportRef?.current?.click();
                  }}
                >
                  Import file excel
                </Button>
              </Flex>
            </Flex>
          </Flex>
        </CardHeader>
        <CardBody overflowX="auto">
          <Stack overflow={'auto'}>
            <SizeTable categoryData={categoryData?.data || []} handleUpdateCategory={handleUpdateItem} refetch={refetch} />
          </Stack>
          <Flex justifyContent={'flex-end'}>
            <Pagination
              page={categoryData?.pagination?.page}
              pageLength={categoryData?.pagination?.pageSize}
              totalRecords={categoryData?.pagination?.count}
              onPageChange={(page, pageLength) => {
                setFilter({
                  ...filter,
                  pageSize: pageLength,
                  pageIndex: page - 1,
                });
              }}
            />
          </Flex>
        </CardBody>
      </Card>
      {isCreateModalOpen && (
        <CreateCategoryModal categorysDetail={sizeEditing} isOpen={isCreateModalOpen} onClose={handelCloseModal} refetch={refetch} />
      )}
      {isExportModalOpen && (
        <ExportModal totalRecords={categoryData?.pagination?.count} isOpen={isExportModalOpen} onClose={handelCloseModal} handleExport={handleExport}/>
      )}
    </Flex>
  );
}

export default Category;
